export const formatStatsAndType = (str) => {
    return str?.replace(/(?:^|\b|-)\w/g, function(match) {
        return match.toUpperCase();
    }).replace(/_/g, '-');
}
